import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AutosizeDirective } from './autosize.directive';

export * from './autosize.directive';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ AutosizeDirective ],
  exports: [ AutosizeDirective ]
})
export class AutosizeModule {

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/autosize/autosize.module.ts